module.exports = __webpack_public_path__ + "static/media/RecomendaParaty2.18494af3.jpg";